import React, {useState, useRef, useEffect} from "react";
import {useOutletContext} from "react-router-dom";
import {useSelector} from "react-redux";
import {Message, Modal, Breadcrumb, Card, Grid, Form, Space, Button, Input, Select, Switch, Table} from "@arco-design/web-react";
import {IconRefresh, IconClose, IconCloseCircle, IconCheckCircle, IconPlusCircle, IconDelete} from "@arco-design/web-react/icon";
import {Scrollbars} from "react-custom-scrollbars-2";
import PropTypes from "prop-types";

import Util from "../../../../../nowui-common/js/util";

import Error from "../../../../../nowui-common/component/error";
import File from "../../../../../nowui-common/component/file";
import Loading from "../../../../../nowui-common/component/loading";

const PlanDetail = ({...props}) => {
    const outletContext = useOutletContext();
    const main = useSelector((store) => store.main);
    const controller = new AbortController();
    const request = useRef(false);
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [isRefresh, setIsRefresh] = useState(false);
    const [errorTitle, setErrorTitle] = useState("");
    const [errorList, setErrorList] = useState([]);
    const [breadcrumb, setBreadcrumb] = useState({});
    const [breadcrumbList, setBreadcrumbList] = useState([]);
    const [selectedIdList, setSelectedIdList] = useState([]);
    const [planItemList, setPlanItemList] = useState([]);
    const [companyDepartmentList, setCompanyDepartmentList] = useState([]);
    const [companyUserList, setCompanyUserList] = useState([]);

    useEffect(() => {
        let breadcrumb = {};
        let breadcrumbList = Util.getBreadcrumb(outletContext, main.menuList, "/plan/index");
        if (props.action == "save") {
            breadcrumb = {
                name: outletContext.intl.formatMessage({id: "global.new"}) + outletContext.intl.formatMessage({id: "plan"}).toLowerCase(),
            };

            handleLoadPlan();
        } else if (props.action == "update") {
            breadcrumb = {
                name: outletContext.intl.formatMessage({id: "global.modify"}) + outletContext.intl.formatMessage({id: "plan"}).toLowerCase(),
            };

            handleLoadPlan();

            setIsRefresh(true);
        }
        setBreadcrumb(breadcrumb);
        setBreadcrumbList(breadcrumbList.concat([breadcrumb]));

        return () => {
            controller.abort();
        };
    }, []);

    useEffect(() => {
        setErrorTitle("");
        setErrorList([]);

        return () => {};
    }, [localStorage.getItem("locale")]);

    const handleLoadPlan = () => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);
        setErrorTitle("");
        setErrorList([]);

        Util.request(outletContext, {
            url: process.env.API_URL + "/plan/frontend/website/v1/item",
            controller: controller,
            data: {
                planId: props.planId,
            },
            success: (response) => {
                form.setFieldsValue(response.data);

                setPlanItemList(response.data.planItemList);
                setCompanyDepartmentList(response.data.companyDepartmentList);
                setCompanyUserList(response.data.companyUserList);

                request.current = false;
                setIsLoad(false);
            },
            error: (response) => {
                Message.error(response.message);

                setErrorTitle(response.message);
                setErrorList(response.error);

                request.current = false;
                setIsLoad(false);
            },
            complete: () => {},
        });
    };

    const handleSubmitPlan = () => {
        if (props.action == "save") {
            handleSavePlan();
        } else if (props.action == "update") {
            handleUpdatePlan();
        }
    };

    const handleSavePlan = () => {
        if (request.current) {
            return;
        }

        form.validate()
            .then((data) => {
                if (request.current) {
                    return;
                }
                request.current = true;

                Message.loading({
                    id: "loading",
                    content: outletContext.intl.formatMessage({id: "global.loading"}),
                    duration: 0,
                });

                setIsLoad(true);
                setErrorTitle("");
                setErrorList([]);

                data.planItemList = planItemList;

                Util.request(outletContext, {
                    url: process.env.API_URL + "/plan/frontend/website/v1/save",
                    controller: controller,
                    data: data,
                    success: (response) => {
                        Message.success({
                            id: "loading",
                            content: response.message,
                        });

                        request.current = false;
                        setIsLoad(false);

                        props.onSubmit();
                    },
                    error: (response) => {
                        Message.error({
                            id: "loading",
                            content: response.message,
                        });

                        setErrorTitle(response.message);
                        setErrorList(response.error);

                        request.current = false;
                        setIsLoad(false);
                    },
                    complete: () => {},
                });
            })
            .catch((error) => {
                if (process.env.NODE_ENV == "development") {
                    console.log(error);
                }
            });
    };

    const handleUpdatePlan = () => {
        if (request.current) {
            return;
        }

        form.validate()
            .then((data) => {
                if (request.current) {
                    return;
                }
                request.current = true;

                Message.loading({
                    id: "loading",
                    content: outletContext.intl.formatMessage({id: "global.loading"}),
                    duration: 0,
                });

                setIsLoad(true);
                setErrorTitle("");
                setErrorList([]);

                data.planId = props.planId;
                data.planItemList = planItemList;

                Util.request(outletContext, {
                    url: process.env.API_URL + "/plan/frontend/website/v1/update",
                    controller: controller,
                    data: data,
                    success: (response) => {
                        Message.success({
                            id: "loading",
                            content: response.message,
                        });

                        request.current = false;
                        setIsLoad(false);

                        props.onSubmit();
                    },
                    error: (response) => {
                        Message.error({
                            id: "loading",
                            content: response.message,
                        });

                        setErrorTitle(response.message);
                        setErrorList(response.error);

                        request.current = false;
                        setIsLoad(false);
                    },
                    complete: () => {},
                });
            })
            .catch((error) => {
                if (process.env.NODE_ENV == "development") {
                    console.log(error);
                }
            });
    };

    return (
        <React.Fragment>
            <Modal
                style={{top: "100px", width: main.width - 300 <= 1024 ? main.width + "px" : main.width - 300 + "px"}}
                title={
                    <React.Fragment>
                        <div className="arco-modal-title-text">{breadcrumb.name}</div>
                        <Space>
                            <Button
                                className="arco-modal-title-button"
                                type="text"
                                icon={<IconRefresh className="navigation_icon" />}
                                onClick={() => {
                                    handleLoadPlan();
                                }}
                            ></Button>
                            <Button
                                className="arco-modal-title-button"
                                type="text"
                                icon={<IconClose className="navigation_icon" />}
                                onClick={() => {
                                    props.onClose();
                                }}
                            ></Button>
                        </Space>
                    </React.Fragment>
                }
                visible={props.visible}
                focusLock={false}
                alignCenter={false}
                maskClosable={false}
                closeIcon={false}
                footer={
                    <div style={{display: "flex", alignItems: "center"}}>
                        <div style={{flex: 1, marginRight: "8px"}}></div>
                        <Space>
                            <Button
                                icon={<IconCloseCircle />}
                                onClick={() => {
                                    props.onClose();
                                }}
                            >
                                {outletContext.intl.formatMessage({id: "global.close"})}
                            </Button>
                            {props.action === "save" ? (
                                <Button
                                    type="primary"
                                    icon={<IconCheckCircle />}
                                    loading={isLoad}
                                    onClick={() => {
                                        handleSubmitPlan();
                                    }}
                                >
                                    {outletContext.intl.formatMessage({id: "global.save"})}
                                </Button>
                            ) : null}
                            {props.action === "update" ? (
                                <Button
                                    type="primary"
                                    icon={<IconCheckCircle />}
                                    loading={isLoad}
                                    onClick={() => {
                                        handleSubmitPlan();
                                    }}
                                >
                                    {outletContext.intl.formatMessage({id: "global.update"})}
                                </Button>
                            ) : null}
                        </Space>
                    </div>
                }
            >
                <Scrollbars
                    autoHeight
                    autoHeightMax={main.height - 300}
                    renderView={({style, ...props}) => {
                        style.overflow = isLoad ? "hidden" : "auto";

                        return <div className="scrollbar" style={style} {...props} />;
                    }}
                >
                    <div style={{width: main.width - 300 <= 1024 ? main.width + "px" : main.width - 300 + "px"}}>
                        <Breadcrumb className="breadcrumb">
                            {breadcrumbList.map((breadcrumb, breadcrumbIndex) => {
                                return <Breadcrumb.Item key={breadcrumbIndex}>{breadcrumb.name}</Breadcrumb.Item>;
                            })}
                        </Breadcrumb>
                        <Error errorTitle={errorTitle} errorList={errorList} setErrorTitle={setErrorTitle} setErrorList={setErrorList} />
                        <Form form={form} autoComplete="off" layout="vertical">
                            <Card className="card" title={outletContext.intl.formatMessage({id: "global.basicInformation"})} bordered={false}>
                                <Grid.Row gutter={20}>
                                    <Grid.Col xs={24} sm={12} md={8} lg={6}>
                                        <Form.Item
                                            label={outletContext.intl.formatMessage({id: "plan.planStatus"})}
                                            field="planStatus"
                                            rules={[
                                                {
                                                    required: true,
                                                },
                                            ]}
                                            triggerPropName="checked"
                                            initialValue={true}
                                        >
                                            <Switch
                                                checkedText={outletContext.intl.formatMessage({id: "global.on"})}
                                                uncheckedText={outletContext.intl.formatMessage({id: "global.off"})}
                                            />
                                        </Form.Item>
                                    </Grid.Col>
                                    <Grid.Col xs={24} sm={12} md={8} lg={6}>
                                        <Form.Item
                                            label={outletContext.intl.formatMessage({id: "plan.planName"})}
                                            field="planName"
                                            rules={[
                                                {
                                                    required: true,
                                                },
                                                {
                                                    type: "string",
                                                    minLength: 0,
                                                    maxLength: 50,
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder={outletContext.intl.formatMessage({id: "global.pleaseEnter"})}
                                                allowClear
                                                onPressEnter={() => {
                                                    handleSubmitPlan();
                                                }}
                                            />
                                        </Form.Item>
                                    </Grid.Col>
                                    <Grid.Col xs={24} sm={12} md={8} lg={6}>
                                        <Form.Item
                                            label={outletContext.intl.formatMessage({id: "plan.planLocation"})}
                                            field="planLocation"
                                            rules={[
                                                {
                                                    required: true,
                                                },
                                                {
                                                    type: "string",
                                                    minLength: 0,
                                                    maxLength: 50,
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder={outletContext.intl.formatMessage({id: "global.pleaseEnter"})}
                                                allowClear
                                                onPressEnter={() => {
                                                    handleSubmitPlan();
                                                }}
                                            />
                                        </Form.Item>
                                    </Grid.Col>
                                </Grid.Row>
                                <Grid.Row gutter={20}>
                                    <Grid.Col xs={24} sm={12} md={8} lg={6}>
                                        <Form.Item
                                            label="排查部门"
                                            field="checkDepartmentId"
                                            rules={[
                                                {
                                                    required: true,
                                                },
                                            ]}
                                        >
                                            <Select
                                                placeholder={outletContext.intl.formatMessage({id: "global.pleaseSelect"})}
                                                allowClear
                                                onChange={(event) => {}}
                                            >
                                                {companyDepartmentList.map((companyDepartment, companyDepartmentIndex) => {
                                                    return (
                                                        <Select.Option key={companyDepartmentIndex} value={companyDepartment.departmentId}>
                                                            {companyDepartment.departmentName}
                                                        </Select.Option>
                                                    );
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Grid.Col>
                                    <Grid.Col xs={24} sm={12} md={8} lg={6}>
                                        <Form.Item
                                            label="排查员工"
                                            field="checkUserId"
                                            rules={[
                                                {
                                                    required: true,
                                                },
                                            ]}
                                        >
                                            <Select
                                                placeholder={outletContext.intl.formatMessage({id: "global.pleaseSelect"})}
                                                allowClear
                                                onChange={(event) => {}}
                                            >
                                                {companyUserList.map((companyUser, companyUserIndex) => {
                                                    return (
                                                        <Select.Option key={companyUserIndex} value={companyUser.userId}>
                                                            {companyUser.userName}
                                                        </Select.Option>
                                                    );
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Grid.Col>
                                    <Grid.Col xs={24} sm={12} md={8} lg={6}>
                                        <Form.Item
                                            label="整改员工"
                                            field="rectifyUserId"
                                            rules={[
                                                {
                                                    required: true,
                                                },
                                            ]}
                                        >
                                            <Select
                                                placeholder={outletContext.intl.formatMessage({id: "global.pleaseSelect"})}
                                                allowClear
                                                onChange={(event) => {}}
                                            >
                                                {companyUserList.map((companyUser, companyUserIndex) => {
                                                    return (
                                                        <Select.Option key={companyUserIndex} value={companyUser.userId}>
                                                            {companyUser.userName}
                                                        </Select.Option>
                                                    );
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Grid.Col>
                                </Grid.Row>
                            </Card>
                            <Card className="card" title={outletContext.intl.formatMessage({id: "plan.planItem"})} bordered={false}>
                                <div className="card_table_action">
                                    <Space className="action_detail" wrap>
                                        <Button
                                            icon={<IconPlusCircle />}
                                            onClick={() => {
                                                planItemList.push({
                                                    itemId: Util.getId(),
                                                    itemName: null,
                                                    itemImage: null,
                                                });
                                                setPlanItemList([...planItemList]);
                                            }}
                                        >
                                            {outletContext.intl.formatMessage({id: "global.save"})}
                                        </Button>
                                        <Button
                                            icon={<IconDelete />}
                                            disabled={selectedIdList.length == 0}
                                            onClick={() => {
                                                for (let i = 0; i < selectedIdList.length; i++) {
                                                    for (let j = 0; j < planItemList.length; j++) {
                                                        if (selectedIdList[i] == planItemList[j].itemId) {
                                                            planItemList.splice(j, 1);
                                                            break;
                                                        }
                                                    }
                                                }
                                                setPlanItemList([...planItemList]);
                                            }}
                                        >
                                            {outletContext.intl.formatMessage({id: "global.delete"})}
                                        </Button>
                                    </Space>
                                    <Table
                                        className="table"
                                        columns={[
                                            {
                                                dataIndex: "itemName",
                                                title: outletContext.intl.formatMessage({id: "plan.itemName"}),
                                                render: (col, record, index) => (
                                                    <React.Fragment>
                                                        <Input
                                                            placeholder={outletContext.intl.formatMessage({id: "global.pleaseEnter"})}
                                                            allowClear
                                                            value={record.itemName}
                                                            onChange={(event) => {
                                                                planItemList[index].itemName = event;
                                                                setPlanItemList([...planItemList]);
                                                            }}
                                                        />
                                                    </React.Fragment>
                                                ),
                                            },
                                            {
                                                dataIndex: "itemImage",
                                                title: outletContext.intl.formatMessage({id: "plan.itemImage"}),
                                                render: (col, record, index) => (
                                                    <React.Fragment>
                                                        <File
                                                            type="image"
                                                            limit={1}
                                                            value={record.itemImage}
                                                            onChange={(event) => {
                                                                planItemList[index].itemImage = event;
                                                                setPlanItemList([...planItemList]);
                                                            }}
                                                        />
                                                    </React.Fragment>
                                                ),
                                            },
                                        ]}
                                        rowKey="itemId"
                                        data={planItemList}
                                        childrenColumnName="childrenList"
                                        rowSelection={{
                                            type: "checkbox",
                                            columnWidth: 50,
                                            selectedRowKeys: selectedIdList,
                                            onChange: (selectedRowKeys) => {
                                                setSelectedIdList(Util.getSelectedIdList(selectedIdList, planItemList, "itemId", selectedRowKeys));
                                            },
                                        }}
                                        border={false}
                                        pagination={false}
                                    />
                                </div>
                            </Card>
                        </Form>
                        <div className="card_bottom"></div>
                    </div>
                </Scrollbars>
                {isLoad ? <Loading /> : null}
            </Modal>
        </React.Fragment>
    );
};

PlanDetail.propTypes = {
    visible: PropTypes.bool.isRequired,
    action: PropTypes.string.isRequired,
    planId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default Util.withRouter(PlanDetail);
